import { render, staticRenderFns } from "./CustomerManager.vue?vue&type=template&id=cefcaebe&"
import script from "./CustomerManager.vue?vue&type=script&lang=js&"
export * from "./CustomerManager.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports